import api from '@/services/Api';


export class RegionCodeService {
  async getRegionCodeList() {
    const response = await api.get('/region-code/all')
    return response.data
  }
}

export default new RegionCodeService()
